import { SxProps, Theme } from '@mui/material/styles';

export const locationSearchInputStyles = {
  searchInput: {
    flex: 1,
    '& .MuiOutlinedInput-root': {
      borderRadius: '40px',
      backgroundColor: 'common.white',
      padding: '0 24px 0 12px',
      height: '44px',
      minHeight: 'unset',
      '& fieldset': {
        borderColor: 'neutral1.medium',
      },
      '&:hover fieldset': {
        borderColor: 'neutral1.medium',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'primary.main',
        borderWidth: '1px',
      },
    },
    '& .MuiInputBase-input': {
      padding: '10px 0 10px 12px',
      fontSize: '16px',
      fontFamily: '"Work Sans", sans-serif',
      color: 'neutral1.600',
      height: 'auto',
      lineHeight: '24px',
      '&::placeholder': {
        color: 'neutral1.600',
        opacity: 1,
      },
    },
  } as SxProps<Theme>,

  searchIcon: {
    color: 'text.secondary',
    cursor: 'pointer',
  } as SxProps<Theme>,
};